


































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';
import { BMOS_URL } from '../main';

function polarToCartesian(centerX: number, centerY: number, radius: number, angleInDegrees: number) {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians)),
  };
}

function describeArc(x: number, y: number, radius: number, startAngle: number, endAngle: number) {

    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    const d = [
        'M', start.x, start.y,
        'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
    ].join(' ');

    return d;
}

@Component({
    components: {},
})
export default class SolarVsGrid extends Vue implements EnergyDisplay {
    public static MAX_POWER_VALUE: number = 2.0; // Max kw for circle
    public static MIN_SIZE = 2; // Number of Concentric circles / SIZE
    public static MAX_SIZE = 10; // Number of Concentric circles / SIZE

    private dialog: boolean = false;
    private notifications: boolean = false;
    private sound: boolean = true;
    private widgets: boolean = false;

    private solar_pv_power: number = 0.0;
    private import_export_power: number = 0.0;
    private consumption_power: number = 0.0;
    private import_or_export_class: string = 'vs-grid-import';
    private consumption_size: number = 2;
    private pv_size: number = 2;
    private import_export_size: number = 2;
    private circles: number = 0;
    private internal_temp: string = '0.0';
    private external_temp: string = '0.0';

    private clockHandler: any;

    public created() {
        // this.houseData = new HouseData(shimmy, user);
        // this.clockHandler = setInterval(function(parent) {
        //   this.update();
        // }.bind(this), 30000);
    }

    public async update() {

        const temps = await this.readTemps();

        if (temps) {
            this.internal_temp = temps[0].toFixed(1).toString();
            this.external_temp = temps[1].toFixed(1).toString();
        }

        return;
    }

    public async mounted() {

        const arc1: Element = this.$refs.arc1 as Element;
        const arc1_icon: HTMLElement = this.$refs.arc1_icon as HTMLElement;
        arc1.setAttribute('d', describeArc(10, 10, 7, 0, 270));
        // arc1_icon.style.left = '40px';
        // arc1_icon.style.top = '115px';

        const arc2: Element = this.$refs.arc2 as Element;
        const arc2_icon: HTMLElement = this.$refs.arc2_icon as HTMLElement;
        arc2.setAttribute('d', describeArc(10, 10, 7, 0, 90));
        // arc2_icon.style.left = '40px';
        // arc2_icon.style.top = '115px';

        this.update();
    }

    // curl -X POST http://carneab4.memset.net:1337/hisRead -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5" --data $'ver:"3.0" granularity:"second" aggregate:"avg"\nid,range\n[@9941983, @9941936],"2020-09-02"'
    public readTemps() {

      const self = this;

      const headers = {
        headers: { 'Content-Type': 'text/plain', 'authorization': 'BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5' },
      };

      // const start = moment().subtract(5, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
      // const zinc = 'ver:"3.0" granularity:"second" aggregate:"avg"\nid,range\n[@9941983, @9941936],"--START--"'.replace('--START--', start);

      const zinc = 'ver:"3.0" granularity:"second" aggregate:"avg"\nid,range\n[@9941983, @9941936],"lastfiveminutes"';

      return axios.post(BMOS_URL + '/hisRead', zinc, headers)
        .then((response) => {

          if (response.data !== undefined && response.data !== null) {

              const lines = response.data.split('\n');
              const last_line = lines.slice(Math.max(lines.length - 1, 0));
              const temps = last_line[0].split(',');
              const external = temps[1];
              const internal = temps[2];

              return [+internal, +external];
          }

          return false;
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response.data);
            return false;
          }
        });
    }

}
